module.exports = __webpack_public_path__ + "static/img/main.768c0a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main.png
// module id = qIEg
// module chunks = 1